var e = "_wrapper_q3yel_1",
    p = "_wrapperTruncated_q3yel_8",
    r = "_wrapperPale_q3yel_12",
    a = "_input_q3yel_16",
    t = {
  wrapper: e,
  wrapperTruncated: p,
  wrapperPale: r,
  input: a
};
export { t as default, a as input, e as wrapper, r as wrapperPale, p as wrapperTruncated };